import Immutable from "immutable";

import types from "./types";
import { RESET_GIVING_FORM } from "../types";

export const initialState = Immutable.fromJS({
  currentRoute: "selection",
  routes: ["selection", "donate", "thank-you", "success", "server-error"],
  previousPage: "",
  isModalOpen: false,
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.NEXT_PAGE: {
      let indexOfCurrentRoute = state.get("routes").indexOf(state.get("currentRoute"));

      if (indexOfCurrentRoute > -1 && indexOfCurrentRoute < state.get("routes").count()) {
        const indexOfNewRoute = ++indexOfCurrentRoute;
        const newRoute = state.get("routes").toArray()[indexOfNewRoute];
        const previousPage = state.get("routes").toArray()[indexOfCurrentRoute];

        return state.withMutations((state) => {
          state.set("currentRoute", newRoute).set("previousPage", previousPage);
        });
      }
    }

    case types.SET_CURRENT_PAGE:
      return state.set("currentRoute", action.page);

    case types.TOGGLE_MODAL:
      return state.set("isModalOpen", action.bool);

    case types.PREVIOUS_PAGE:
      let indexCurrent = state.get("routes").indexOf(state.get("currentRoute"));

      if (indexCurrent > 0 && indexCurrent <= state.get("routes").count()) {
        const indexNew = --indexCurrent;
        const newRouteName = state.get("routes").toArray()[indexNew];
        const previousPage = state.get("routes").toArray()[indexCurrent];

        return state.withMutations((state) => {
          state.set("currentRoute", newRouteName).set("previousPage", previousPage);
        });
      }

    case RESET_GIVING_FORM:
      return initialState;

    default:
      return state;
  }
};
